// generated by genversion
export var version = '4.7.11';
//# sourceMappingURL=version.js.map